import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';

const SeleccionMedico = () => {
  const { user } = useAuth();
  const [medicos, setMedicos] = useState([]);
  const [medicoAsignado, setMedicoAsignado] = useState(null);

  useEffect(() => {
    if (user?.id) {
      fetchMedicos();
      fetchMedicoAsignado();
    }
  }, [user]);

  const fetchMedicos = async () => {
    try {
      const res = await axios.get('/api/users/lista-medicos'); // Ruta para obtener lista de médicos
      setMedicos(res.data);
    } catch (err) {
      console.error('Error al obtener médicos:', err);
    }
  };

  const fetchMedicoAsignado = async () => {
    try {
      const res = await axios.get(`/api/users/asignado/${user.id}`);
      setMedicoAsignado(res.data.medico || null);
    } catch (err) {
      console.error('Error al obtener médico asignado:', err);
    }
  };


  const handleSeleccion = async (idmedico) => {
    try {
      await axios.post('/api/users/asignar', {
        iduser: user.id,
        idmedico,
      });
      fetchMedicoAsignado(); // Actualiza vista
    } catch (err) {
      console.error('Error al asignar médico:', err);
    }
  };

  return (
     <div className="max-w-5xl mx-auto mt-6 p-6 bg-white shadow-md rounded-xl">
      {/* Título a la izquierda */}
      <h2 className="text-2xl font-bold mb-2 text-left">Selecciona a tu médico</h2>

      {/* Texto descriptivo */}
      <p className="text-gray-600 mb-6 text-left">
        Nuestros médicos están certificados, cuentan con experiencia clínica comprobada y están comprometidos con tu
        salud. Al seleccionar a un médico, podrás tener seguimiento personalizado, mayor control sobre tu progreso y
        acceso prioritario a consultas y consejos de salud. Esta selección puede cambiarse más adelante si lo deseas.
      </p>

      {/* Médico asignado */}
      <div className="mb-8">
        {medicoAsignado ? (
          <div className="border border-green-300 bg-green-50 p-4 rounded shadow text-gray-800">
            <h3 className="text-lg font-semibold text-green-700 mb-2">Médico asignado</h3>
            <p><strong>Nombre:</strong> Dr. {medicoAsignado.name} {medicoAsignado.apellidos}</p>
            <p><strong>Especialidad:</strong> {medicoAsignado.especialidad}</p>
            <p><strong>Teléfono:</strong> {medicoAsignado.telefono}</p>
            <p><strong>Cédula:</strong> {medicoAsignado.cedula}</p>
            <p><strong>Clínica:</strong> {medicoAsignado.clinica || 'No registrada'}</p>
          </div>
        ) : (
          <div className="text-red-600 font-semibold text-center">Sin médico seleccionado</div>
        )}
      </div>

      {/* Tabla de médicos */}
      <div className={`overflow-x-auto ${medicoAsignado ? 'opacity-50 pointer-events-none' : ''}`}>
        <table className="min-w-full bg-white border rounded-lg overflow-hidden shadow">
          <thead className="bg-gray-100">
            <tr>
              <th className="py-3 px-4 text-left">Nombre</th>
              <th className="py-3 px-4 text-left">Especialidad</th>
              <th className="py-3 px-4 text-left">Teléfono</th>
              <th className="py-3 px-4 text-left">Cédula</th>
              <th className="py-3 px-4 text-left">Clínica</th>
              <th className="py-3 px-4 text-center">Acción</th>
            </tr>
          </thead>
          <tbody>
            {medicos.map((medico) => (
              <tr key={medico.idmedico} className="border-t">
                <td className="py-2 px-4">{`Dr. ${medico.name} ${medico.apellidos}`}</td>
                <td className="py-2 px-4">{medico.especialidad}</td>
                <td className="py-2 px-4">{medico.telefono}</td>
                <td className="py-2 px-4">{medico.cedula}</td>
                <td className="py-2 px-4">{medico.clinica || 'No registrada'}</td>
                <td className="py-2 px-4 text-center">
                  <button
                    disabled={!!medicoAsignado}
                    onClick={() => handleSeleccion(medico.idmedico)}
                    className={`px-4 py-1 rounded text-white text-sm ${
                      medicoAsignado
                        ? 'bg-gray-400 cursor-not-allowed'
                        : 'bg-blue-600 hover:bg-blue-700'
                    }`}
                  >
                    Seleccionar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SeleccionMedico;
